import { Component } from '@angular/core';

@Component({
  selector: 'app-wo-external',
  templateUrl: './wo-external.component.html',
  styleUrls: ['./wo-external.component.css']
})
export class WoExternalComponent {

}
